
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { HeaderStyle } from 'types/header';
import { Link } from 'types/layout';
import NavigationLinkDesktop from '@components/header/navigation/desktop/navigation-link-desktop.vue';

@Component({
	components: {
		NavigationLinkDesktop
	}
})
export default class DesktopNavTemplate extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	get isAuthenticated(): boolean {
		return app.isAuthenticated;
	}

	get logoLink(): Link {
		return this.isAuthenticated ? { router: 'account-overview' } : { router: 'home' };
	}
}
